var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_17525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1401 5C7.2001 5.89 7.3501 6.76 7.5901 7.59L6.3901 8.79C5.9801 7.59 5.7201 6.32 5.6301 5H7.1401ZM17.0001 17.02C17.8501 17.26 18.7201 17.41 19.6001 17.47V18.96C18.2801 18.87 17.0101 18.61 15.8001 18.21L17.0001 17.02ZM8.1001 3H4.6001C4.0501 3 3.6001 3.45 3.6001 4C3.6001 13.39 11.2101 21 20.6001 21C21.1501 21 21.6001 20.55 21.6001 20V16.51C21.6001 15.96 21.1501 15.51 20.6001 15.51C19.3601 15.51 18.1501 15.31 17.0301 14.94C16.9301 14.9 16.8201 14.89 16.7201 14.89C16.4601 14.89 16.2101 14.99 16.0101 15.18L13.8101 17.38C10.9801 15.93 8.6601 13.62 7.2201 10.79L9.4201 8.59C9.7001 8.31 9.7801 7.92 9.6701 7.57C9.3001 6.45 9.1001 5.25 9.1001 4C9.1001 3.45 8.6501 3 8.1001 3Z",
    fill: "#84919A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_17525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.33cb3ad2e45a0a03185d64abcdc041ee.svg";
export { ForwardRef as ReactComponent };